export const SOCKET_CONNECTION_STATE_CONNECTED = "Connected";
export const SOCKET_CONNECTION_STATE_DISCONNECTED = "Disconnected";
export const SOCKET_CONNECTION_STATE_CONNECTING = "Connecting";
export const SOCKET_CONNECTION_STATE_DISCONNECTING = "Disconnecting";
export const SOCKET_CONNECTION_STATE_RECONNECTING = "Reconnecting";
